<template>
    <div class="table__responsive">
        <table class="table">
            <thead>
                <tr class="table__row--header">
                    <th>{{$t('widgets.year_graph.columns.year')}}</th>
                    <th>{{$t('widgets.year_graph.columns.value')}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="row.year">
                    <td>{{row.year}}</td>
                    <td>{{$n(row.value, 'money')}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class YearTable extends Vue {
        @Prop({
            type: Array,
            default: () => ([
                {year: 0, value: 0},
                {year: 1, value: 1},
            ])
        })
        rows;
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/year-graph/YearTable.vue